module.exports = __webpack_public_path__ + "static/img/ico-banner-arrow-l.642b23df.svg";